/* import __COLOCATED_TEMPLATE__ from './fin-readiness.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';
import type ThemeService from 'embercom/services/theme-service';

interface Args {}

export default class FinReadiness extends Component<Args> {
  @service declare appService: AppService;
  @service declare store: Store;
  @service declare themeService: ThemeService;
  @tracked totalVolume = '';

  get serializedReport() {
    let range;
    if (this.appService.app.hasGettingStartedBackfill) {
      range = 'past_12_months';
    } else {
      range = 'past_4_weeks';
    }

    return {
      id: 'fin-readiness',
      date_range: {
        selection: range,
      },
    };
  }

  @action
  setTotalVolume(totalVolume: string) {
    this.totalVolume = totalVolume;
  }

  get videoThumbnail1xAssetUrl() {
    // these will be replaced when we have the actual assets, they're copied from another component
    return assetUrl('/assets/images/automation/fin-readiness/fin-readiness-thumb@1x.svg');
  }

  get loopAssetUrl() {
    if (this.themeService.darkModeEnabled) {
      return assetUrl('/assets/images/automation/fin-readiness/attd-loop-dark.svg');
    }
    return assetUrl('/assets/images/automation/fin-readiness/attd-loop.svg');
  }

  get finIconUrl() {
    if (this.themeService.darkModeEnabled) {
      return assetUrl('/assets/images/automation/fin-readiness/fin-icon-dark-mode.svg');
    }
    return assetUrl('/assets/images/automation/fin-readiness/fin-icon-light-mode.svg');
  }

  get wistiaId() {
    return 'rf65anms15';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::FinReadiness': typeof FinReadiness;
  }
}
